/**
 * **checkIfCanScroll**_(element, threshold)_<br>
 * Determines if a given element is scrollable if content is overflown.
 * @param { HTMLElement } element: The dom element to check if it's scrollable.
 * @param { Number } threshold: Add a threshold to scrolling position to determine if scrollable.
 * @returns { Object } Scrolling definition if element is scrollable up, down, left or right.
 */
export const checkIfCanScroll = (element: HTMLElement, threshold = 0) => {
  if (element) {
    const { scrollLeft, scrollTop, scrollHeight, scrollWidth, offsetHeight, offsetWidth } = element;
    const scrollHorizonatalDistance = scrollWidth - offsetWidth;
    const scrollVerticalDistance = scrollHeight - offsetHeight;
    return {
      canScrollLeft: scrollLeft > threshold,
      canScrollRight: scrollLeft < scrollHorizonatalDistance - threshold,
      canScrollDown: scrollTop > threshold,
      canScrollUp: scrollTop < scrollVerticalDistance - threshold,
    };
  }
  return {
    canScrollDown: false,
    canScrollLeft: false,
    canScrollRight: false,
    canScrollUp: false,
  };
};
